import React from "react";
import ReactSelect, {
  StylesConfig,
  MultiValue,
  ActionMeta,
} from "react-select";

interface NetwalaMultiSelectProps {
  height?: string;
  onChange?: (value: (string | number)[]) => void;
  options: Array<NetwalaSelectOptions>;
  value?: (string | number)[];
  showSearch?: boolean;
  disabled?: boolean;
  placeHolder?: string;
}

type OptionType = {
  value: string | number;
  label: string;
};

const NetwalaMultiSelect: React.FC<NetwalaMultiSelectProps> = ({
  height = "45px",
  onChange,
  options,
  value = [],
  showSearch = true,
  disabled = false,
  placeHolder = "Select options",
}) => {
  const reactSelectOptions: OptionType[] = options.map((opt) => ({
    value: opt.value,
    label: opt.label,
  }));

  const selectedValues: OptionType[] = reactSelectOptions.filter((opt) =>
    value.includes(opt.value)
  );

  const customStyles: StylesConfig<OptionType, true> = {
    control: (base, state) => ({
      ...base,
      minHeight: height,
      height: "auto",
      borderColor: state.isFocused ? "#1890ff" : "#d9d9d9",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(24, 144, 255, 0.2)"
        : "none",
      "&:hover": {
        borderColor: "#1890ff",
      },
      borderRadius: "6px",
      padding: "2px 0",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#1890ff",
      borderRadius: "4px",
      padding: "0",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#ffffff",
      fontSize: "13px",
      fontWeight: 400,
      padding: "2px 6px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#ffffff",
      borderRadius: "0 4px 4px 0",
      padding: "0 4px",
      "&:hover": {
        backgroundColor: "#40a9ff",
        color: "#ffffff",
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: "#bfbfbf",
      fontSize: "14px",
    }),
    input: (base) => ({
      ...base,
      fontSize: "14px",
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#1890ff"
        : state.isFocused
        ? "#e6f7ff"
        : "#ffffff",
      color: state.isSelected ? "#ffffff" : "#000",
      "&:active": {
        backgroundColor: "#1890ff",
        color: "#ffffff",
      },
    }),
  };

  const handleChange = (
    selectedOptions: MultiValue<OptionType>,
    actionMeta: ActionMeta<OptionType>
  ) => {
    const values = selectedOptions
      ? selectedOptions.map((opt) => opt.value)
      : [];
    if (onChange) {
      onChange(values);
    }
  };

  return (
    <ReactSelect<OptionType, true>
      isMulti
      isDisabled={disabled}
      options={reactSelectOptions}
      value={selectedValues}
      onChange={handleChange}
      placeholder={placeHolder}
      isSearchable={showSearch}
      styles={customStyles}
      className="netwala-react-select"
      classNamePrefix="netwala-select"
    />
  );
};

export default NetwalaMultiSelect;

